const ARENO_API_ENDPOINT = process.env.REACT_APP_BACKEND_API_END_POINT;

export default ARENO_API_ENDPOINT;